import Image from 'next/image';
import { CDN2 } from '@/helpers/api';

export default function OurPartners() {
  return (
    <div className="w-full bg-white">
      <div className="mx-auto px-4 md:px-32 xl:px-4 space-y-6 max-w-7xl py-16">
        <h2 className="text-xl lg:text-3xl font-bold text-center">
          Some Partners
        </h2>
        <div className="flex flex-col md:flex-row justify-center items-center gap-6">
          {[
            { src: '/staticmyapp/partnerus/the-westin-logo.png', alt: 'The Westin' },
            { src: '/staticmyapp/partnerus/ipark-logo.png', alt: 'iPark' },
            { src: '/staticmyapp/partnerus/wally-logo.png', alt: 'Wally Park' },
            { src: '/staticmyapp/partnerus/fine-logo.webp', alt: 'Fine Airport Park' }
          ].map(({ src, alt }, i) => (
            <div
              key={i}
              className="w-80 h-24 flex items-center justify-center bg-white border"
            >
              <Image
                src={CDN2() + src}
                alt={alt}
                width={100}
                height={40}
                className="object-contain"
                quality={100}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
